<template>
  <el-tooltip
    v-if="features.STARTUP_FOLLOW"
    :content="follows ? 'Remove from shortlist' : 'Add to shortlist'"
    placement="top"
    :disabled="disabled"
  >
    <el-button
      size="small"
      :loading="isFollowingInProgress"
      :disabled="disabled"
      class="w-32 text-center"
      @click="toggle()"
    >
      <svg
        v-show="follows && !isFollowingInProgress"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        class="w-4 h-4 inline mr-1"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
      {{ text }}
    </el-button>
    <el-checkbox
      v-if="false"
      v-loading="isFollowingInProgress"
      class="w-36 mb-0"
      :value="follows"
      :label="follows ? 'Shortlisted' : 'Add to shortlist'"
      style="height: 30px;"
      border
      @change="(follows) => setFollows({ follows })"
    />
  </el-tooltip>
</template>

<script>
import { features } from 'utils/features'
import useStartupFollow from './useStartupFollow'
import { computed } from '@vue/composition-api'

export default {
  props: {
    startupId: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    follows: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const {
      startFollowing,
      stopFollowing,
      isFollowingInProgress,
    } = useStartupFollow({ startupId: props.startupId })

    const setFollows = async ({ follows }) => {
      emit('input', follows)
      if (follows) {
        await startFollowing()
      } else {
        await stopFollowing()
      }
    }

    const toggle = () => {
      setFollows({ follows: !props.follows })
    }

    const text = computed(() => {
      if (isFollowingInProgress.value) {
        return 'Processing'
      }
      if (props.follows) {
        return 'Shortlisted'
      } else {
        return 'Shortlist'
      }
    })

    return {
      features,
      setFollows,
      isFollowingInProgress,
      toggle,
      text,
    }
  },
}
</script>
